(function () {
  'use strict';

  window.TrackOrderDemoProvider = {
    async lookup(input) {
      return {
        orderNumber: input.orderId,
        currentStatus: 'In Transit',
        currentStage: 2,
        trackingNumber: 'DEMO-TRACKING-NUMBER',
        courierName: 'Demo Courier',
        lastUpdate: 'Demo date and time',
        estimatedDelivery: 'Demo delivery date',
        shipmentUrl: null,
        isDemo: true
      };
    }
  };
})();
